const applyPattern = ({ text, pattern, cursor = (text === null || text === void 0 ? void 0 : text.length) || 0 }) => {
    if (!text || text.length === 0 || !pattern || cursor < text.length) {
        return [text, cursor];
    }
    const sanitizedText = text.replace(/\D/g, '');
    const formattedObject = pattern.split('').reduce((acc, character) => {
        if (acc.remainingText.length === 0) {
            return acc;
        }
        if (character !== '.') {
            return {
                formattedText: acc.formattedText + character,
                remainingText: acc.remainingText
            };
        }
        return {
            formattedText: acc.formattedText + acc.remainingText[0],
            remainingText: acc.remainingText.slice(1)
        };
    }, { formattedText: '', remainingText: sanitizedText.split('') });
    const formattedText = formattedObject.formattedText;
    const newCursor = formattedText.length;
    return [formattedText, newCursor];
};
export { applyPattern };
//# sourceMappingURL=applyPattern.js.map